// extracted by mini-css-extract-plugin
export var articleCardContainer = "further-informations-module--articleCardContainer--685c3";
export var articlesContainer = "further-informations-module--articlesContainer--1fd10";
export var carouselButtons = "further-informations-module--carouselButtons--578ee";
export var container = "further-informations-module--container--71e98";
export var nextButton = "further-informations-module--nextButton--10df7";
export var pictogram = "further-informations-module--pictogram--4cf7c";
export var prevButton = "further-informations-module--prevButton--ca3da";
export var sectionTitle = "further-informations-module--sectionTitle--436f9";